import { SpdrClientViewModel } from "../../../../ViewModel/SpdrClientViewModel";
import { PdsrClientViewModel } from "../../../../ViewModel/PdsrClientViewModel";
import { isArrayUndefinedOrEmpty } from "../../../../../Utils/arrays";

export function isSpdrOrPdsrChanged(
  templateSpdrOrPdsr: SpdrClientViewModel | PdsrClientViewModel,
  spdrOrPdsr: SpdrClientViewModel | PdsrClientViewModel
) {
  const isShipFrequencyChanged = templateSpdrOrPdsr.ShipFrequency !== spdrOrPdsr.ShipFrequency;

  if (isShipFrequencyChanged) {
    return true;
  }

  if (
    (!templateSpdrOrPdsr.ODCs && spdrOrPdsr.ODCs) ||
    (templateSpdrOrPdsr.ODCs && !spdrOrPdsr.ODCs)
  ) {
    return true;
  }

  if (!templateSpdrOrPdsr.ODCs && !spdrOrPdsr.ODCs) {
    return isShipFrequencyChanged;
  }

  if (
    isArrayUndefinedOrEmpty(templateSpdrOrPdsr.ODCs) ||
    isArrayUndefinedOrEmpty(spdrOrPdsr.ODCs)
  ) {
    return false;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < templateSpdrOrPdsr.ODCs.length; i++) {
    if (templateSpdrOrPdsr.ODCs[i].LoadType !== spdrOrPdsr.ODCs[i].LoadType) {
      return true;
    }
  }
  return isShipFrequencyChanged;
}
